import React from 'react';

const FACEBOOK_EMBED_HEIGHT = 280;

const facebookEmbeds = [
  {
    name: 'Pietro Baker',
    href: 'https://www.facebook.com/runfreepietro/posts/pfbid0co5fnjv4yJkcThTEvPjPrnhwi7dbwQoB7ZaPbsRSZ4P5zN1SrSXo8caMg67wWZinl',
  },
  {
    name: 'Michael Nwosu',
    href: 'https://www.facebook.com/michael.nwosu.7/posts/pfbid033awUtcDYch2NWwVj45BTdUbanVp3Nuw6frfFv9RoyyoREJLoWr1PGMyWCZGzHV3Zl',
  },
  {
    name: 'Kogit Labs',
    href: 'https://www.facebook.com/permalink.php?story_fbid=pfbid02JLAaYA5ux7R937cRTqqqak5yrqRG1HSHQzZkYyMXp5znuLLFVopGZSFAuphUceyWl&id=61577999825193',
  },
];

const buildEmbedUrl = (href: string) =>
  `https://www.facebook.com/plugins/post.php?href=${encodeURIComponent(href)}&show_text=true&width=500`;

interface FacebookReviewsProps {
  heading?: string;
  subheading?: string;
  className?: string;
}

const FacebookReviews: React.FC<FacebookReviewsProps> = ({
  heading = 'What Clients Say on Facebook',
  subheading = 'Recommendations from clients we’ve worked with.',
  className = '',
}) => {
  return (
    <section className={`px-4 py-14 sm:py-20 ${className}`}>
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-[#1877F2]/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.28em] text-[#1877F2] dark:bg-[#1877F2]/15">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-3.5 w-3.5">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
            Facebook Recommendations
          </div>
          <h2 className="mx-auto max-w-4xl text-3xl font-semibold leading-tight text-slate-950 md:text-5xl dark:text-white">
            {heading}
          </h2>
          {subheading && (
            <p className="mx-auto mt-4 max-w-2xl text-base text-slate-600 dark:text-slate-400">
              {subheading}
            </p>
          )}
        </div>

        <div className="grid justify-center gap-6 md:grid-cols-2 lg:grid-cols-3">
          {facebookEmbeds.map(({ name, href }) => (
            <div
              key={href}
              className="flex justify-center rounded-[1.75rem] border border-[#e7e0cf] bg-white p-3 shadow-[0_16px_40px_rgba(15,23,42,0.08)] dark:border-white/10 dark:bg-slate-900/65"
            >
              <iframe
                title={`Facebook review by ${name}`}
                src={buildEmbedUrl(href)}
                width="500"
                height={FACEBOOK_EMBED_HEIGHT}
                style={{ border: 'none', overflow: 'hidden', maxWidth: '100%' }}
                scrolling="no"
                frameBorder={0}
                allowFullScreen
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FacebookReviews;
